import { globalWindow } from './getWindow'

export const document = globalWindow?.document
